import "./modelstyle.scss";

import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CPopover,
  CRow,
} from "@coreui/react";
import { ClickableElementModal, InputFieldDatasetMapModal } from "./Models";
import {
  useModelVersionDatasets,
  useModelVersionInputFields,
} from "./ModelService";

import CIcon from "@coreui/icons-react";
import { PropTypes } from "prop-types";
import React from "react";
import Table from "react-bootstrap/Table";
import { freeSet } from "@coreui/icons";
import { useUserInfo } from "../users/UserService";

function filterObjectByKeys(original_obj, keep_keys) {
  const filtered = Object.keys(original_obj)
    .filter((key) => keep_keys.includes(key))
    .reduce((obj, key) => {
      obj[key] = original_obj[key];
      return obj;
    }, {});

  return filtered;
}

function ClickableInfo(props) {
  // All props passed into enclosing div, except where specified
  return (
    <div className="clickable-info" id={props.info.name} {...props}>
      <CPopover
        header={`${props.info.name} Description`}
        content={props.info.description}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0 .5em 0 .5em",
          }}
        >
          <CIcon content={props.icon} />
          <div style={{ margin: "0 5px 0 5px" }}>{props.info.name}</div>
        </div>
      </CPopover>
    </div>
  );
}

ClickableInfo.propTypes = {
  info: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  icon: PropTypes.string.isRequired,
};

export function ModelVersionConfig(props) {
  const { data: modelVersionDataset } = useModelVersionDatasets(
    props.model.id,
    props.modelversion.version_number,
  );
  const { data: ModelVersionInputFields } = useModelVersionInputFields(
    props.model.id,
    props.modelversion.version_number,
  );

  const { data: user } = useUserInfo(props.modelversion.user_id);

  return (
    <div>
      <Table size="sm" style={{ maxWidth: "100%", tableLayout: "fixed" }}>
        <tbody>
          <tr>
            <td style={{ width: "20%" }}>Created By: </td>
            <td>{user?.user_display_name || ""}</td>
          </tr>
          <tr>
            <td>Create Date: </td>
            <td>
              {" "}
              {new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: false,
              }).format(Date.parse(props.modelversion.create_date))}
            </td>
          </tr>
          <tr>
            <td>Mapped Datasets:</td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                {modelVersionDataset?.length > 0 ? (
                  modelVersionDataset.map((dataset, idx) => {
                    return (
                      <ClickableElementModal
                        key={idx}
                        clickable={
                          <ClickableInfo
                            info={dataset}
                            key={idx}
                            icon={freeSet.cilSpreadsheet}
                          />
                        }
                        modal={
                          <InputFieldDatasetMapModal
                            {...props}
                            dataset={dataset}
                          />
                        }
                      />
                    );
                  })
                ) : (
                  <>No Datasets Mapped!</>
                )}
              </div>
            </td>
          </tr>
          <tr>
            <td>Required Input Fields:</td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                {ModelVersionInputFields?.length > 0 ? (
                  ModelVersionInputFields.map((mvif, idx) => {
                    return (
                      <ClickableInfo
                        info={mvif}
                        key={idx}
                        icon={freeSet.cilListNumbered}
                      />
                    );
                  })
                ) : (
                  <>No Fields Added!</>
                )}
              </div>
            </td>
          </tr>
          <tr>
            <td>Version Notes:</td>
            <td>N/A</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

ModelVersionConfig.propTypes = {
  model: PropTypes.object.isRequired,
  modelversion: PropTypes.object.isRequired,
};

export default class ModelDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      model_config: null,
    };
  }

  componentDidMount() {}

  render() {
    const mc = this.state.model_config;
    return (
      <CCard>
        <CCardHeader>
          Model Name Information
          <small className="card-header-action float-right">
            ID:{this.model_id}
          </small>
        </CCardHeader>
        <CCardBody>
          <ModelConfigDisplay mc={mc} />
        </CCardBody>
      </CCard>
    );
  }
}

export class ModelConfigDisplay extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <BaseModel base_model={this.props.mc.base_model} />
        <hr></hr>
        <ModelConfig model_config={this.props.mc.model_config} />
        <hr></hr>
        <SourceData source_data={this.props.mc.source_data} />
      </div>
    );
  }
}

ModelConfigDisplay.propTypes = {
  mc: PropTypes.object.isRequired,
};

export class ModelConfig extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <KVMap kvps={this.props.model_config} />;
  }
}

ModelConfig.propTypes = {
  model_config: PropTypes.array.isRequired,
};

function BaseModel(props) {
  return (
    <KeyValuePairDisplay k="Model Base Architecture" v={props.base_model} />
  );
}

BaseModel.propTypes = {
  base_model: PropTypes.string.isRequired,
};

export class SourceData extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
        Inputs
        <CRow style={{ marginTop: "15px" }}>
          <CCol xs="12" sm="6" md="4">
            <KVMap kvps={this.props.source_data.input} />
          </CCol>
          {/* </CRow> */}

          {/* <CRow style={{ marginTop: "15px" }}> */}
          <CCol xs="12" sm="6" md="4">
            <KVMap kvps={this.props.source_data.target} />
          </CCol>
        </CRow>
      </>
    );
  }
}

SourceData.propTypes = {
  source_data: PropTypes.object.isRequired,
};

const KeyValuePairDisplay = ({ k, v }) => {
  return (
    <CCard>
      <CCardHeader>
        <small>{k}</small>
      </CCardHeader>
      <CCardBody>{v}</CCardBody>
    </CCard>
  );
};

KeyValuePairDisplay.propTypes = {
  k: PropTypes.string.isRequired,
  v: PropTypes.string.isRequired,
};

const KVMap = ({ kvps }, Component) => {
  // maps key value pairs that exist in kvps to the keyvalue pair display component
  return Object.entries(kvps).map((kv_pair) => {
    const [k, v] = kv_pair;
    return <Component key={k} k={k} v={v} />;
  });
};
